@if (isLoading()) {
    <div class="d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
    </div>
}@else {
    <div class="card rounded-4 mb-3 border-0">
        <div class="card-body p-0">
            <ul class="list-group" [ngClass]="{'list-container-scroll': jobOffers().length > 5}">
                <li class="list-group-item list-group-item-job" *ngFor="let item of jobOffers()">
                    <div class="row align-items-center">
                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4" [routerLink]="['/home','job',item.id]" style="cursor: pointer;">
                            @if(item.logoUrl && isUserLoggedIn()){
                            <img [src]="item.logoUrl" onerror="this.error=null; this.src='assets/Images/logo-compania.jpg'" alt="Logo" class="img-fluid logo-company" />
                            }@else{
                                <img src="assets/Images/logo-compania.jpg" alt="Logo" class="img-fluid logo-company" />
                            }
                        </div>
                        <div class="col-xl-10 col-lg-10 col-md-10 col-sm-9 col-8">
                            <div class="d-flex align-items-center mb-1">
                                <a [routerLink]="['/home','job',item.id]" class="text-decoration-none fs-5 fw-bold mt-0 mb-0 d-block">
                                    {{ item.title }}
                                </a>
                                <!-- Badge de vistas -->
                                <span class="badge bg-light text-dark ms-2 d-flex align-items-center">
                                    <i class="fa-regular fa-eye me-1"></i>
                                    {{ getViewCount(item.id) }}
                                </span>
                                <!-- Mostrar el badge de estado solo para ofertas aplicadas -->
                                @if(appliedOffers() && item.jobApplicationStatusId) {
                                    <span class="badge ms-2" [ngClass]="getStatusBadgeClass(item.jobApplicationStatusId)">
                                        {{ item.jobApplicationStatusName }}
                                    </span>
                                }
                            </div>
                            <div class="d-flex align-items-center mb-2">
                                <i class="fa-regular fa-building text-primary me-1"></i>
                                <a [routerLink]="['/home','job',item.id]" class="text-decoration-none text-muted">
                                    @if(isUserLoggedIn()){
                                        {{ item.ownerFullName }}
                                    }@else{
                                        <span class="private-info">Información privada (Inicia sesión para ver)</span>
                                    }
                                </a>
                            </div>
                            <!-- @if(!isUserLoggedIn()){
                                <div class="alert alert-info py-2 mb-2">
                                    <i class="fas fa-info-circle me-1"></i>
                                    <strong>Inicia sesión</strong> para conocer la empresa y más ofertas laborales.
                                </div>
                            } -->
                            <p class="mt-0 mb-3 text-secondary">
                                {{item.description}}
                            </p>
                            <div class="row">
                                <div class="col-md-4 col-sm-6 col-12 mb-2">
                                    <div class="d-flex align-items-center">
                                        <div class="icon-bg me-2">
                                            <i class="fa-regular fa-clock text-primary"></i>
                                        </div>
                                        <div>
                                            <label class="fw-bold d-block mb-0 small text-secondary">Duración del Contrato</label>
                                            <span>{{ item.contractDurationName }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-12 mb-2">
                                    <div class="d-flex align-items-center">
                                        <div class="icon-bg me-2">
                                            <i class="fa-regular fa-calendar text-primary"></i>
                                        </div>
                                        <div>
                                            <label class="fw-bold d-block mb-0 small text-secondary">Fecha de Publicación</label>
                                            <span>{{ item.publicOn| date : 'dd/MM/yyyy'}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-sm-6 col-12 mb-2">
                                    <div class="d-flex align-items-center">
                                        <div class="icon-bg me-2">
                                            <i class="fa-solid fa-location-dot text-primary"></i>
                                        </div>
                                        <div>
                                            <label class="fw-bold d-block mb-0 small text-secondary">Ubicación</label>
                                            <span>
                                                <span *ngIf="item.countryName">{{ item.countryName }}</span>
                                                <span *ngIf="item.stateName"> / {{ item.stateName }}</span>
                                                <span *ngIf="item.cityName"> / {{ item.cityName }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="list-group-item text-center" *ngIf="thereAreNoJobOffers()">
                    <div class="d-flex flex-column align-items-center">
                        <i class="fa-solid fa-briefcase fa-2x text-primary mb-2"></i>
                        <span class="text-secondary">
                            <ng-container *ngIf="appliedOffers(); else noOffers">
                                No has aplicado a ninguna oferta laboral.
                            </ng-container>
                            <ng-template #noOffers>
                                No hay ofertas laborales disponibles.
                            </ng-template>
                        </span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
}

<app-pagination 
    *ngIf="!thereAreNoJobOffers()" 
    class="mt-3" 
    [page]="page" 
    [pageSize]="pageSize" 
    [totalItems]="totalItems" 
    (pageChange)="onPageChange($event)" 
    (pageSizeChange)="onPageSizeChange($event)">
</app-pagination>
